import React from 'react'

export default props => (
    <button className="btn-preview-video" onClick={props.onClick}>
        <img id="btn-p-img1" alt={props.alt} src={props.imgSrc} className="img-responsive img-thumbnail" />
        <img id="btn-p-img2" alt={props.alt} src={props.imgSrc2} className="img-responsive img-thumbnail" />
    </button>
)